import React, { useState } from 'react';
import { Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Trans } from 'react-i18next';
import { Control, LocalForm } from 'react-redux-form';
import { Page, required, DatePicker, SubmitButton, FormGroup } from 'components/common';
import { NotificationManager } from 'react-notifications';
import Select from 'react-select';

const AddAssetType = ({ isOpen, toggle, onSave, assetAccounts, t }) => {
    const [enabledField, setEnabledField] = useState("");

    const handleSubmit = (values) => {

        const bookDepreciationSetting = {
            depreciationMethod: values.depreciationMethod,
            averagingMethod: values.averagingMethod,
            depreciationRate: enabledField === 'depreciationRate' ? values.depreciationRate : null,
            depreciationCalculationMethod: "None",
            effectiveLifeYears: values.effectiveLifeYears || null
        };
        const transformedValues = {
            assetTypeName: values.assetTypeName,
            fixedAssetAccountId: values.fixedAssetAccountId,
            accumulatedDepreciationAccountId: values.accumulatedDepreciationAccountId,
            depreciationExpenseAccountId: values.depreciationExpenseAccountId,
            bookDepreciationSetting,
        };
        onSave(transformedValues);
      };



    return (
        <Modal isOpen={isOpen} toggle={toggle}>
                <Page title={t("Add Asset Type")}>
                <LocalForm  model="assetTypeForm" onSubmit={(values) => handleSubmit(values)}>

                    <Row form className='mt-2'>
                        <Col md={12}>
                            <FormGroup label={t("Asset Type Name")}>
                                <Control.text
                                    model=".assetTypeName"
                                    className="form-control"
                                    id="assetTypeName"
                                    style={{ backgroundColor: '#F4F7FE' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form className='mt-2'>
                        <Col md={12}>
                            <FormGroup label={t("Asset Account")}>
                                <Control.select
                                    model=".fixedAssetAccountId"
                                    className="form-control"
                                    id="asset_account"
                                    style={{ backgroundColor: '#F4F7FE' }}
                                >
                                    {assetAccounts?.map((account, index) => (
                                        <option key={index} value={account?.AccountID}>{account?.Name}</option>
                                    ))}
                                </Control.select>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form className='mt-2'>
                        <Col md={12}>
                            <FormGroup label={t("Accumulated Depreciation Account")}>
                                <Control.select
                                    model=".accumulatedDepreciationAccountId"
                                    className="form-control"
                                    id="accumulated_depreciation_account"
                                    style={{ backgroundColor: '#F4F7FE' }}
                                >
                                    <option value="">{t('Select...')}</option>
                                    {assetAccounts?.map((account, index) => (
                                        <option key={index} value={account?.AccountID}>{account?.Name}</option>
                                    ))}
                                </Control.select>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form className='mt-2'>
                        <Col md={12}>
                            <FormGroup label={t("Depreciation Expense Account")}>
                                <Control.select
                                    model=".depreciationExpenseAccountId"
                                    className="form-control"
                                    id="depreciation_expense_account"
                                    style={{ backgroundColor: '#F4F7FE' }}
                                >
                                    <option value="">{t('Select...')}</option>
                                    {assetAccounts?.map((account, index) => (
                                        <option key={index} value={account?.AccountID}>{account?.Name}</option>
                                    ))}
                                </Control.select>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form className='mt-2'>
                        <Col md={7}>
                            <FormGroup label={t("Depreciation Method *")}>
                                <Control.select
                                    model=".depreciationMethod"
                                    className="form-control"
                                    id="depreciation_method"
                                    style={{ backgroundColor: '#F4F7FE' }}
                                    validators={{ required }}
                                >
                                    <option value="">{t('Select...')}</option>
                                    <option value="NoDepreciation">{t("No Depreciation")}</option>
                                    <option value="StraightLine">{t("Straight Line")}</option>
                                    <option value="DiminishingValue100">{t("Diminishing Value 100")}</option>
                                    <option value="DiminishingValue150">{t("Diminishing Value 150")}</option>
                                    <option value="DiminishingValue200">{t("Diminishing Value 200")}</option>
                                    <option value="FullDepreciation">{t("Full Depreciation")}</option>
                                </Control.select>
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup label={t("Averaging Method *")}>
                                <Control.select
                                    model=".averagingMethod"
                                    className="form-control"
                                    id="averaging_method"
                                    style={{ backgroundColor: '#F4F7FE' }}
                                    validators={{ required }}
                                >
                                    <option value="">{t('Select...')}</option>
                                    <option value="ActualDays">{t("Actual Days")}</option>
                                    <option value="FullMonth">{t("Full Month")}</option>
                                </Control.select>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form className='mt-2'>
                    
                        <Col md={5} style={{ justifyContent:"center", display:"flex", alignItems:"center", marginLeft:"5px" }}>
                        <input
                            type="radio"
                            checked={enabledField === 'depreciationRate'}
                            onChange={() => setEnabledField('depreciationRate')}
                            className='mt-4 mr-2'
                        />
                            <FormGroup label={t("Rate *")}>
                                <Control.text
                                    model=".depreciationRate"
                                    type="number"
                                    className="form-control"
                                    id="rate"
                                    style={{ backgroundColor: '#F4F7FE' }}
                                    // validators={{ required }}
                                    disabled={enabledField !== 'depreciationRate'}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={5} style={{ justifyContent:"center", display:"flex", alignItems:"center", marginLeft:"5px" }}>
                        <input
                            type="radio"
                            checked={enabledField === 'effectiveLifeYears'}
                            onChange={() => setEnabledField('effectiveLifeYears')}
                            className='mt-4 mr-2'
                        />
                            <FormGroup label={t("Effective Life *")}>
                                <Control.text
                                    model=".effectiveLifeYears"
                                    type="number"
                                    className="form-control"
                                    id="effectiveLife"
                                    style={{ backgroundColor: '#F4F7FE' }}
                                    // validators={{ required }}
                                    disabled={enabledField !== 'effectiveLifeYears'}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                
                <ModalFooter style={{paddingRight:"0px", justifyContent:"space-between"}}>
                    <Button color="secondary" onClick={toggle}><Trans>Cancel</Trans></Button>{' '}
                    <Button color="primary" type="submit"><Trans>Save</Trans></Button>
                </ModalFooter>
            </LocalForm>
            </Page>
        </Modal>
    );
};

export default AddAssetType;
